
// ============================================
// MemberScene - メンバー一覧ページシーン
// ============================================

/**
 * GNS.MemberScene
 * * メンバー一覧ページ（/member/）のメイン制御クラス
 */
GNS.MemberScene = function (GNS) {
    // AbstractSceneを継承
    const scene = GNS.create(GNS.AbstractScene);

    /**
     * 初期化処理
     */
    scene.init = function (data) {
        scene._super.init.call(this, data);

        // プロパティ初期化
        this.scrollEnabled = true;
        this.isMove = false;
        this.memberButtons = []; // 旧 playerArray

        // ヘッダーイベントの監視開始
        this._bindHeaderEvents(true);
    };

    /**
     * ロード処理
     */
    scene.load = function () {
        this.isLoading = true;
        this._loadComplete();
    };

    /**
     * ロード完了時の実処理
     */
    scene._bind._loadComplete = function () {
        try {
            this._initMemberButtons();
        } catch (err) {
            console.error('MemberScene _loadComplete error:', err);
        }

        // 親クラスのロード完了処理
        scene._super.load.call(this);
    };

    /**
     * メンバーリスト（ボタン）の初期化ヘルパー
     */
    scene._initMemberButtons = function () {
        const memberLists = this.element.querySelectorAll(".member__list");

        // リストごとの処理
        Array.from(memberLists).forEach((list) => {
            const items = list.querySelectorAll(".member__list__item");

            // アイテムごとの処理
            Array.from(items).forEach((itemNode, index) => {
                const itemObj = new GNS.DisplayObject(itemNode);
                const linkNode = itemNode.querySelector(".item__link");

                // 画像オブジェクトの生成
                let imgObj = null;
                const imgContainer = itemNode.querySelector(".member__list__item__img");
                if (imgContainer) {
                    const imgTag = imgContainer.getElementsByTagName("img")[0];
                    if (imgTag) {
                        imgObj = new GNS.DisplayObject(imgTag);
                    }
                }

                // リンクが存在する場合のみボタン化する
                if (linkNode) {
                    // UIThumBtn(linkEl, bgEl, imgObj, containerObj, ???, delay)
                    const thumbBtn = new GNS.UIThumBtn(
                        linkNode,
                        null,     // bgElement (null)
                        imgObj,   // image object
                        itemObj,  // container object
                        null,     // extra param
                        0.05 * index // 遅延係数
                    );

                    this.memberButtons.push(thumbBtn);
                }
            });
        });
    };

    /**
     * 表示ハンドラ
     */
    scene.showHandler = function () {
        // 必要に応じて実装
    };

    /**
     * 非表示ハンドラ
     */
    scene.hideHandler = function () {
        this._bindHeaderEvents(false);
    };

    /**
     * リセットハンドラ
     * 生成したボタンインスタンスを破棄
     */
    scene.resetHandler = function () {
        this.memberButtons.forEach(btn => {
            if (btn.kill) btn.kill();
        });
        this.memberButtons = [];
    };

    /**
     * ヘッダーイベントのバインド/アンバインド管理
     */
    scene._bindHeaderEvents = function (shouldBind) {
        const header = GNS.Header.getInstance();
        const method = shouldBind ? "addEventListener" : "removeEventListener";

        header[method]("nav_open", this.openedMenu);
        header[method]("nav_close", this.closedMenu);
    };

    /**
     * メニューが開いた時の処理
     */
    scene._bind.openedMenu = function () {
        this.scrollEnabled = false;
    };

    /**
     * メニューが閉じた時の処理
     */
    scene._bind.closedMenu = function () {
        this.scrollEnabled = true;
    };

    /**
     * スクロールハンドラ
     */
    scene.scrollHandler = function () { };

    return scene._self;
}(GNS);
